import {useIntl} from "react-intl";
import * as React from "react";
import { Placeholder, StyledButtonMob } from './index';
import { DeviceHardwareEnum } from '../../../DeviceHardwareEnum';
import { LabelEnum } from '../../LabelEnum';
import Map from "../../../../Elements/Icon/Icons/settings/Map";
import {Capabilities} from "@Safemate/Settings/Store/types";

interface MapProps{
  noAccess?: boolean;
  deviceId: number
  lastMsgIn: number;
  capabilities: Capabilities;
}

const MapAction = ({ lastMsgIn, deviceId, capabilities, noAccess }: MapProps) => {

  if(!lastMsgIn || !capabilities.positioning || noAccess) return <Placeholder/>;

  const { formatMessage } = useIntl();

  return(
    <StyledButtonMob
      title={formatMessage({id: LabelEnum.SHOW_MAP, defaultMessage: "Kartvisning"})}
      onClick={(event: any) => {
        event.stopPropagation();
        location.hash = `mapsingle/${deviceId}`;
      }}
      onKeyDown={(event: any) => {
        if (event.key === 'Enter') 
          location.hash = `mapsingle/${deviceId}`;
      }}
    >
      <Map
        tabIndex="0"
        size="medium"
        inline
      />
    </StyledButtonMob>
  )
};

export default MapAction;
